module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1091"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1091"
    },
    "bundlingPackage": "conversations-visitor-ui",
    "bundlingPackageVersion": "static-1.28316",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};